import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component  from './registration.component'

import MyProfile              from './my-profile'
import MyToolbox              from './my-toolbox'
import MyRlink                from './my-rlink'
import RegistrationHelper     from './helper/registration.helper'

let module = angular.module('registration', [
  uiRouter,
  MyProfile,
  MyToolbox,
  MyRlink
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('registration', {
      url: '/registration',
      component: 'registration',
      redirectTo: 'registration.myProfile',
      myRenaultForbidden: true,
      authenticatedForbidden: true
    })
})
.component('registration', component)
.service('RegistrationHelper', RegistrationHelper)
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/registration/index.js